import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Observable, Subscription } from "rxjs";


@Component({
  selector: 'confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent {
  @Output() eventEmitter = new EventEmitter<object>();
  modalTitle: string;
  modalHtml: SafeHtml;
  modalRef: BsModalRef;
  subscriptions: Subscription[] = [];

  constructor(
    private modalService: BsModalService,
    private changeDetection: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
  ) {}

  openModal(template: TemplateRef<any>) {
    console.log("Opening modal for navigation confirmation.");

    this.initVars();
    this.initEvents();
    this.modalRef = this.modalService.show(template);
  }

  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  // handle button click; send event to calling component
  confirm(): void {
    this.eventEmitter.emit({confirm: true});
    this.modalRef.hide();
  }

  // handle button click; send event to calling component
  decline(): void {
    this.eventEmitter.emit({cancel: true});
    this.modalRef.hide();
  }

  closeModal() {
    this.modalRef.hide();
  }

  private initVars() {
    this.modalTitle = "Confirm Page Change";

    // setting this.modalHtml from htmlToTrust
    const htmlToTrust: string = "<p>You have item(s) in the search results checked. Navigating from this page will clear those. Are you sure you wish to change the page of results?</p>";
    this.modalHtml = this.sanitizer.bypassSecurityTrustHtml(htmlToTrust);
  }

  private initEvents () {
    // setting up for watchable events
    const combine = Observable.combineLatest(
      this.modalService.onShow,
      this.modalService.onShown,
      this.modalService.onHide,
      this.modalService.onHidden
    ).subscribe(() => this.changeDetection.markForCheck());

    // watched events
    this.subscriptions.push(
      this.modalService.onHide.subscribe((reason: string) => {
        const _reason = reason ? `, dismissed by ${reason}` : '';
        console.log("onHide event has been fired", _reason);
        this.eventEmitter.emit({cancel: true});
      })
    );
    this.subscriptions.push(
      this.modalService.onHidden.subscribe((reason: string) => {
        const _reason = reason ? `, dismissed by ${reason}` : '';
        console.log("onHidden event has been fired", _reason);
        this.unsubscribe();
      })
    );
    this.subscriptions.push(combine);
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/orders/search/confirmation-modal/confirmation-modal.component.ts